import React, { useState, Fragment } from "react"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { isInKioskMode, moment, thousandSeparator } from "utils"
import ShiftCashierCloseShiftModal from "./ShiftCashierCloseShiftModal"
import { Button, ShiftCashierSeparator, } from "components"
import classes from "./ShiftCashierReport.module.scss"
import clsx from "clsx"

const ShiftCashierReport = () => {
  const [t, i18n] = useTranslation()

  const history = useHistory()

  const shiftCashier =
    useSelector(state => state.shiftCashier)

  const { _id: accountId } =
    useSelector(state => state.userAccountInfo)

  const [showCloseShiftModal, setShowCloseShiftModal] = useState(false)

  const handleNavigate = () => {
    history.push("/cash-managment")
  }

  const {
    startingCash,
    startAt,
    paidIns,
    paidOuts,
    taxesAndCharges,
    refund,
    discounts,
    payments
  } = shiftCashier[accountId]

  const cashTypes = Object.keys(payments)

  const totalTendered =
    cashTypes.reduce((t, cashType) => t += payments[cashType], 0)

  const totalPaidIns =
    paidIns.reduce((t, paidIn) => t += paidIn.amount, 0)

  const totalPaidOuts =
    paidOuts.reduce((t, paidOut) => t += paidOut.amount, 0)

  const expectedCashAmount =
    Math.round(
      (payments["نقدی"] || 0) +
      startingCash +
      totalPaidIns -
      totalPaidOuts -
      refund
    )

  const grossSales =
    totalTendered + discounts

  const netSales =
    totalTendered - taxesAndCharges - refund

  const kioskMode = isInKioskMode()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["container"]}>
        <div className={classes["wrapper"]}>
          {
            !kioskMode &&
            <div className={classes["header"]}>
              <Button
                color="warning"
                onClick={() => history.push("/shift-cashier-history")}
              >
                {t("شیفت_های_قبلی")}
              </Button>
            </div>
          }

          <div className={classes["section"]}>
            <div className={classes["row"]}>
              <div>
                {t("شروع_شیفت")}
              </div>
              <div className={classes["date"]}>
                {moment(startAt).format("jYYYY/jM/jD - HH:mm")}
              </div>
            </div>
          </div>

          <div className={classes["section"]}>
            {cashTypes.map(cashType =>
              <div key={cashType} className={classes["row"]}>
                <div>
                  {cashType}
                </div>
                <div>
                  {thousandSeparator(payments[cashType])}
                </div>
              </div>
            )}

            <div className={classes["row"]}>
              <div>
                {t("تخفیف_ها")}
              </div>
              <div>
                {thousandSeparator(discounts)}
              </div>
            </div>

            <ShiftCashierSeparator />

            <div className={classes["row"]}>
              <b>
                {t("فروش_ناخالص")}
              </b>
              <b>
                {thousandSeparator(grossSales)}
              </b>
            </div>

            <div className={classes["row"]}>
              <b>
                {t("دریافتی_از_مشتری")}
              </b>
              <b>
                {thousandSeparator(totalTendered)}
              </b>
            </div>
          </div>

          <div className={classes["section"]}>
            <div className={classes["row"]}>
              <div>
                {t("پول_مرجوعی")}
              </div>
              <div>
                {thousandSeparator(refund)}
              </div>
            </div>

            <div className={classes["row"]}>
              <div>
                {t("مالیات_و_خدمات")}
              </div>
              <div>
                {thousandSeparator(taxesAndCharges)}
              </div>
            </div>

            <ShiftCashierSeparator />

            <div className={classes["row"]}>
              <b>
                {t("فروش_خالص")}
              </b>
              <b>
                {thousandSeparator(netSales)}
              </b>
            </div>
          </div>

          <div className={classes["section"]}>
            <div className={classes["row"]}>
              <div>
                {t("پول_اولیه_صندوق")}
              </div>
              <div>
                {thousandSeparator(startingCash)}
              </div>
            </div>

            <div className={classes["row"]}>
              <div>
                {t("واریز_به_صندوق")}
              </div>
              <div>
                {thousandSeparator(totalPaidIns)}
              </div>
            </div>

            <div className={classes["row"]}>
              <div>
                {t("برداشت_از_صندوق")}
              </div>
              <div>
                {thousandSeparator(totalPaidOuts)}
              </div>
            </div>

            <ShiftCashierSeparator />

            <div className={classes["row"]}>
              <b>
                {t("موجودی_صندوق")}
              </b>
              <b>
                {thousandSeparator(expectedCashAmount)}
              </b>
            </div>
          </div>
        </div>

        <div className={classes["footer"]}>
          {
            !kioskMode &&
            <Button
              color="info"
              onClick={handleNavigate}
              className={clsx(
                classes["button"],
                isLtr && classes["button-ltr"]
              )}
            >
              {t("مدیریت_صندوق")}
            </Button>
          }

          <Button
            color="success"
            onClick={() => setShowCloseShiftModal(true)}
          >
            {t("اتمام_شیفت")}
          </Button>
        </div>
      </div>

      <ShiftCashierCloseShiftModal
        expectedCashAmount={expectedCashAmount}
        showCloseShiftModal={showCloseShiftModal}
        setShowCloseShiftModal={setShowCloseShiftModal}
      />
    </Fragment>
  )
}

export default ShiftCashierReport